import Vue, { CreateElement, RenderContext, VNode } from "vue";
import BaseSpinner from "@/components/BaseSpinner";

export default Vue.extend({
  functional: true,
  props: { loading: { type: Boolean, default: false } },
  render(h: CreateElement, ctx: RenderContext<{ loading: boolean }>): VNode {
    const loading = ctx.props.loading;
    const style = (Array.isArray(ctx.data.style) ? ctx.data.style : [ctx.data.style]).concat([ctx.data.staticStyle]);
    if (!ctx.scopedSlots.default) return h();

    return (
      <div
        style={style}
        class={[...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]), "base-page d-flex __column"]}
        staticClass={ctx.data.staticClass}
      >
        {loading && (
          <div class="d-flex __align-center __justify-center loading-box">
            {h(BaseSpinner, { props: { size: "72px" } })}
          </div>
        )}
        {ctx.scopedSlots.default({})}
      </div>
    );
  },
});
